export type Day =
  | 'Monday'
  | 'Tuesday'
  | 'Wednesday'
  | 'Thursday'
  | 'Friday'
  | 'Saturday'
  | 'Sunday';

export type CutoffTime = string;

export type CutoffDay =
  | 'Same day'
  | '1 day before'
  | '2 days before'
  | 'Next day';

export type CutoffType = 'strict' | 'flexible' | 'no_cutoff';

export const DAYS: Day[] = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

const generateCutoffTimes = (): { value: string; label: string }[] => {
  const times: { value: string; label: string }[] = [];
  const hours = Array.from({ length: 24 }, (_, i) => i);
  const minutes = [0, 30];

  hours.forEach((hour) => {
    minutes.forEach((minute) => {
      const formattedHour = hour.toString().padStart(2, '0');
      const formattedMinute = minute.toString().padStart(2, '0');
      const value = `${formattedHour}:${formattedMinute}`;

      // Convert to 12-hour format for display
      const period = hour >= 12 ? 'PM' : 'AM';
      const hours12 = hour % 12 || 12;
      const label = `${hours12}:${formattedMinute
        .toString()
        .padStart(2, '0')} ${period}`;

      times.push({ value, label });
    });
  });

  // Add end of day option
  times.push({ value: '23:59', label: 'End of day' });
  return times;
};

export const CUTOFF_TIMES = generateCutoffTimes();

export const CUTOFF_DAYS: CutoffDay[] = [
  'Same day',
  '1 day before',
  '2 days before',
  'Next day',
];

export const CUTOFF_TYPES = [
  { value: 'strict', label: 'Strict' },
  { value: 'flexible', label: 'Flexible' },
  { value: 'no_cutoff', label: 'No cutoff' },
];

export const SORT_OPTIONS = [
  { value: 'alphabetical', label: 'Alphabetical' },
  { value: 'orderGuide', label: 'Order Guide' },
];

export interface OrderPreferencesState {
  cutoffType: CutoffType;
  cutoffDays: Record<Day, CutoffDay>;
  cutoffTimes: Record<Day, CutoffTime>;
  sortBy: 'alphabetical' | 'orderGuide';
}

export interface WithCutoffSetting {
  leadTime: number;
  cutoffTime: CutoffTime;
}

export interface CutoffTimes {
  mon?: WithCutoffSetting;
  tue?: WithCutoffSetting;
  wed?: WithCutoffSetting;
  thu?: WithCutoffSetting;
  fri?: WithCutoffSetting;
  sat?: WithCutoffSetting;
  sun?: WithCutoffSetting;
}

export interface SupplierDeliverySetting {
  id: string;
  deliveryDays: Day[];
  cutOffTime: {
    time: CutoffTime;
    type: CutoffType;
  };
  cutoffType: CutoffType;
  cutoffTimes: CutoffTimes;
}
